<template>
  <el-select
    v-model="brandId"
    style="width: 100%;"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.class4Name"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import Appraise from '@/service/appraise'
export default {
  name: 'ClassRemoteSelect',
  props: {
    value: { required: true },
    placeholder: { type: String, default: '请输入类目名称' }
  },
  data() {
    return { loading: false, options: [], config: { pageNum: 1, pageSize: 50 }}
  },
  computed: {
    brandId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    remoteMethod(class4Name) {
      if (this.loading) {
        return
      }
      if (class4Name) {
        this.loading = true
        Appraise.getappraisalclass4s({ pageNum: 1, pageSize: 50, class4Name, status: 1 })
          .then(res => {
            this.loading = false
            const { result, message, records } = res.data
            if ([0, 13].includes(result)) {
              this.options = records
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      }
    }
  }
}
</script>
